// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".query-editor-loading-container{width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:16px}.query-editor-loading-container svg{width:20px;height:20px}.query-editor-loading-overlay-container{width:100%;height:100%;position:absolute;top:0;left:0;background-color:rgba(255,255,255,.5);backdrop-filter:blur(3px);z-index:999}", ""]);
// Exports
module.exports = exports;
